module.exports = __webpack_public_path__ + "static/media/35c6fb7d.jpg";